class FileUpload{
    constructor(){
        this.file = new FormData();
        this.typePath = "";
        this.renameImage = "";
        this.urlFileExist = "";
    }
}
export { FileUpload };